'use client';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Logo } from '../logo';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { ImageCouldFromRemoteServer as Image } from '@/components/images';

export const LoadingPage = () => {
	const { SiteConfigsData, isLoading: isFetchingSiteConfigs } = useGetSiteConfigs();
	if (isFetchingSiteConfigs) return <></>;
	return (
		<div className="loading-page">
			<div className="loading-page__content">
				<div className="loading-page__header">
					<div className="loading-page__logo">
						<Logo />
					</div>
				</div>
				<div className="loading-page__info">
					<div className="loading-page__circle">
						<div className="loading-page__line">
							<span className="loading-page__line-mask"></span>
						</div>
						<div className="loading-page__img">
							{
								SiteConfigsData?.EnableDotLottieLoadingPage ?
									<DotLottieReact
										src={`/lottie/loading.lottie?v=${process.env.NEXT_PUBLIC_FILE_VERSION_ID}`}
										loop
										autoplay
									/>:
									<Image 
										src="/images/loading_moon.svg"
										alt=""
										width="84"
										height="84"
										isGalaxyFolder={true}
									/>
							}
							
						</div>
					</div>
				</div>
				<div className="loading-page__footer">
					<div className="loading-page__footer-loading">Loading</div>
				</div>
			</div>
		</div>
	)
}